import React from "react";
import "./TopBar.css";
import { FiChevronLeft } from "react-icons/fi";
import { LogoutButton } from "../buttons/logoutButton/LogoutButton";

type props = {
  onBackPress?: () => void;
  onLogoutPress?: () => void;
  title?: string;
};

export const TopBar: React.FC<props> = ({
  onBackPress,
  onLogoutPress,
  title,
}) => {
  return (
    <div className="top-bar-container">
      {onBackPress && <FiChevronLeft onClick={onBackPress} size={20} />}
      {title ? <span className="top-bar-title">{title}</span> : null}
      {onLogoutPress && <LogoutButton onPress={onLogoutPress} />}
    </div>
  );
};
